import supabase from 'modules/core/supabase/supabase';

export async function getCurrentBoard(matchId: number): Promise<number | undefined> {
  const row = await supabase.matchChronology.getRow(matchId);
  if (!row) return undefined;
  return row?.templateId ?? undefined;
}
